import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  isAuthenticated,
  logout,
  refreshUserDetails,
} from "../../redux/auth/index";
import { useAppDispatch } from "../../redux/store";

import StepProgress from "../../components/core/StepProgress";
import { useTitle } from "../../utils/UseTitleUtils";
import MarketingHero from "components/marketing/MarketingHero";

interface PurchaseCompletedProps {}

const PurchaseCompleted = (props: PurchaseCompletedProps) => {
  const authenticated = useSelector(isAuthenticated);
  const appDispatch = useAppDispatch();
  const dispatch = useDispatch();
  useTitle("Purchase Completed!");

  useEffect(() => {
    if (authenticated) {
      dispatch(logout());
      appDispatch(refreshUserDetails());
    }
  }, [authenticated, appDispatch, dispatch]);

  return (
    <div className="marketing-page marketing-page--status">
      <main className="marketing-page__main">
        <MarketingHero title="Purchase Completed!" />

        <section className="marketing-page__section">
          <div className="marketing-page__status-card">
            <div className="marketing-page__step-progress">
              <StepProgress
                activeIndex={1}
                data={["PURCHASE", "CREATE ACCOUNT", "COMPANY"]}
                label="Checkout progress"
              />
            </div>
            <h1 className="marketing-page__status-title">
              Purchase Completed!
            </h1>
            <div className="marketing-page__status-copy">
              <p>
                The next step in setting up your account is to confirm your
                email address.
              </p>
              <p className="marketing-page__status-strong">
                Check your designated email account for an email from
                noreply@insite.work
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PurchaseCompleted;
